import { createSlice } from "@reduxjs/toolkit";
import { getDateWhenString } from "common/date-utils";
const initialState = {
    LastOperationDate: undefined,
    SyncInProgress: false
};
const slice = createSlice({
    initialState,
    name: "tenantSettingsReducers",
    reducers: {
        changeTenantState: (state, action) => {
            if (action.payload) {
                Object.assign(state, action.payload);
            }
        },
        updateLastSyncDate: (state, action) => {
            if (state.LastOperationDate === undefined) {
                state.LastOperationDate = action.payload?.LastOperationDate;
                state.SyncInProgress = action.payload?.SyncInProgress;
            }
            else if (action.payload?.LastOperationDate !== undefined) {
                const lastopdate = getDateWhenString(state.LastOperationDate);
                const newdate = getDateWhenString(action.payload.LastOperationDate);
                if (lastopdate < newdate) {
                    state.LastOperationDate = action.payload?.LastOperationDate;
                    state.SyncInProgress = action.payload?.SyncInProgress;
                }
            }
        }
    }
});
export const tenantSettingsReducers = slice.reducer;
export const { changeTenantState } = slice.actions;
export const { updateLastSyncDate } = slice.actions;
